import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M7.928 2.694a.296.296 0 0 0-.416.001L2.791 7.401A1.2 1.2 0 0 0 2.789 9.1l4.719 4.718a.3.3 0 0 0 .424 0 1.2 1.2 0 0 0 0-1.697L4.81 9h9.439a5.25 5.25 0 0 1 0 10.5H4.2A1.2 1.2 0 0 0 3 20.7a.3.3 0 0 0 .3.3h10.95a6.75 6.75 0 1 0 0-13.5H4.81l3.126-3.126a1.183 1.183 0 0 0-.008-1.68Z" }));
export {
  a as default
};
//# sourceMappingURL=return-icon-DmwVg-YL.js.map
